const DEFAULT_TRIAL_COPY_KEYS = {
  signupHeadline: "tryEfortCoachFree-string",
  onboardingTrialCta: "startYourFreeTrial-string",
};

const TRIAL_OFFER_COPY_KEYS = {
  powerlifting_meet: {
    signupHeadline: "tryEfortCoachFreePowerliftingMeet-string",
    onboardingTrialCta: "startYourFreeTrialPowerliftingMeet-string",
  },
};

export const resolveTrialOfferCopyKey = ({ trialOffer, copy } = {}) =>
  TRIAL_OFFER_COPY_KEYS[trialOffer]?.[copy] || DEFAULT_TRIAL_COPY_KEYS[copy];
